// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b6ae7e5f","453":"7a1e02c1","455":"0bd5ae14","977":"149cf6ab"}[chunkId] + ".chunk.js";
};